import type {
    ComputedGetter,
    DebuggerOptions,
    WritableComputedOptions,
    WritableComputedRef,
} from 'vue'
import { computed, type ComputedRef } from 'vue'
import { isDeepEqual } from 'remeda'

function createWrappedGetter<G>(getter: () => G): () => G {
    let data: G | undefined
    return () => {
        const newData = getter()

        if (!data || !isDeepEqual(data, newData)) {
            data = newData
        }

        return data
    }
}

export function createObjectWritableComputed<T, S = T>(
    options: WritableComputedOptions<T, S>,
    debugOptions?: DebuggerOptions
): WritableComputedRef<T, S> {
    return computed<T, S>(
        {
            get: createWrappedGetter(options.get),
            set: options.set,
        },
        debugOptions
    )
}

export function createObjectComputed<T>(
    options: ComputedGetter<T>,
    debugOptions?: DebuggerOptions
): ComputedRef<T> {
    return computed<T>(createWrappedGetter(options), debugOptions)
}
